import script from "./TransactionsForAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsForAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsForAnalysis.vue?vue&type=style&index=0&id=612fa8e2&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-612fa8e2"]])

export default __exports__